import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../stores';

export function StudioAdminRoute({ children }: { children: React.ReactElement }) {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const isStudioUser = user.role === 'Instructor' || user.role === 'StudioOwner';

  if (isStudioUser) {
    return children;
  }

  return <Navigate to="/unauthorized" replace />;
}